import { useParams } from "react-router";
import useOriginApp from "./useOriginApp";

export function useBaseUrlCreateFlow(){
    const {medstarAssociationType} = useParams();
    return useBaseUrlSwitchMAT()(medstarAssociationType);
}

//use this to swithc the association type in the url
export function useBaseUrlSwitchMAT(){
    const originApp = useOriginApp();
    return (medstarAssociationType) => {
        return `/${originApp.path}/new/${medstarAssociationType}`;
    }
}

export function useBaseUrlAuthFlow(){
    const originApp = useOriginApp();
    return `/${originApp.path}/auth`;
}
 